// Vi — Vault Breaker: charges at the squishiest enemy, knocking them up and
// stunning them for 2 turns.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Unit } from "../Unit";
import type { Ability, AbilityHit } from "./Ability";

export const viVaultBreaker: Ability = {
  id: "viVaultBreaker",
  displayName: "Vault Breaker",
  description: "Charges at the squishiest enemy, dealing 2.6× AD + 104 physical damage and stunning for 2 turns.",
  iconId: "ViQ",

  targetShape({ caster, combat }) {
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    const squishiest = findSquishiest(combat.livingUnitsOf(enemyTeam));
    return squishiest ? [squishiest.pos] : [];
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    const target = findSquishiest(combat.livingUnitsOf(enemyTeam));
    if (!target) return [];
    const stats = effectiveStats(caster);
    return [{
      target,
      amount: physicalDamage(stats.ad * 2.6 + 104),
      type: "physical",
      effect: { kind: "stun", duration: 2 },
      viDash: true,
    }];
  },
};

function findSquishiest(enemies: Unit[]): Unit | null {
  if (enemies.length === 0) return null;
  return enemies.reduce((min, e) => {
    const ratio = e.currentHp / Math.max(1, e.def.baseHp);
    const minRatio = min.currentHp / Math.max(1, min.def.baseHp);
    return ratio < minRatio ? e : min;
  });
}
